import React, { Fragment ,Suspense} from "react";
import { Col, Card, CardBody, CardTitle, Progress } from "reactstrap";
import DropDownActions from "../../common/DropDownActions";
import Moment from 'moment';
import LazyLoad from 'react-lazy-load';

const CardViewProjects = React.memo((props) => {
  const { projectList, handleProjectEdit, handleDeleteProject,employeeEditEnable } = props;
  var loginUser = JSON.parse(localStorage.getItem("user"));
  //console.log(projectList);
  return (
    <Fragment>
      { 
      projectList.length > 0 && 
        projectList.map(
          (ListOfProjects, i) => (


            <Col
              key={ListOfProjects.projectID}
              md={4}
              sm={6}
              xl={3}
            >
              <LazyLoad height={550}>
              <Card className="project-crad mb-4">
              
                <CardBody>
                  <CardTitle>
                    <h4 className="project-title">
                      <a href={`/viewProject/${ListOfProjects.projectID}`}>
                      <span>{ListOfProjects.projectName}</span>
                      </a>
                      
                      {(employeeEditEnable||ListOfProjects.managerID==loginUser.EmployeeId)?(
                        <div className="dropDown-action">
                        <DropDownActions
                          selectedOpt={ListOfProjects.activeStatus}
                          dropDownOption={[
                            {
                              action: "Edit",
                              handleAction: () =>
                                handleProjectEdit(
                                  ListOfProjects
                                ),
                            },
                            {
                              action: "Delete",
                              handleAction: () =>
                                handleDeleteProject(
                                  ListOfProjects.projectID
                                ),
                            },
                          ]}
                        ></DropDownActions>
                      </div>
                      ):null}
                      
                    </h4>
                  </CardTitle>
                  {/* <small className="block text-ellipsis m-b-15">
                    <span className="text-xs">1</span>{" "}
                    <span className="text-muted">open tasks, </span>
                    <span className="text-xs">9</span>{" "}
                    <span className="text-muted">tasks completed</span>
                  </small> */}
                  <span className="text-muted mt-3 project-description">
                    {(ListOfProjects.projectDescription !== undefined && ListOfProjects.projectDescription !== null) ? (((ListOfProjects.projectDescription).length > 50) ? 
    (((ListOfProjects.projectDescription).substring(0,47)) + '...') : 
    ListOfProjects.projectDescription ) :null }
                    {/* {ListOfProjects.projectDescription} */}
                  </span>
                  <div className="mt-3">
                    <h4 className="project-title mb-1">Deadline :</h4>
                    <div className="text-muted">
                      {" "}
                      { Moment(ListOfProjects.endDate).format("DD MMM YYYY")}
                    </div>
                  </div>
                  <div className="mt-3">
                    <h4 className="project-title">Project Leader :</h4>
                    <ul className="team-members">
                      {/* {ListOfProjects.managerName} */}
                      {/* {project.projectLeaders.map((leader, i) => ( */}
                      <li>
                        <a
                          href="#null"
                          data-toggle="tooltip"
                          title={ListOfProjects.managerName}
                        >
                          <img
                            alt=""
                            src={ListOfProjects.managerPciture == null || ListOfProjects.managerPciture =="null" || ListOfProjects.managerPciture =='undefined'? (require(`../../../img/employee/user.png`)) : (require(`../../../img/employee/` + ListOfProjects.managerPciture))}
                            // src={require(`../../../img/employee/${
                            //   ListOfProjects.projectList[0]?.managerPicture ??
                            //   "user.png"
                            // }`)}
                          />
                           
                        </a>
                      </li>
                      {/* ))} */}
                    </ul>
                  </div>
                  {(ListOfProjects.projectManagerList != null || ListOfProjects.projectManagerList !=undefined)? (ListOfProjects.projectManagerList.length != 0 ? (<div className="mt-3">
                    <h4 className="project-title">Team Managers :</h4>
                    <ul className="team-members">
                      {ListOfProjects.projectManagerList !== undefined ? (ListOfProjects.projectManagerList.map(
                        (member, i) => (
                          <li key={i}>
                            <a
                              href="#null"
                              data-toggle="tooltip"
                              title={member.employeeName}
                            >
                              <img
                                alt=""
                                src={!member.profilePicture || member.profilePicture == "null" || member.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (require(`../../../img/employee/user.png`))}
                              />
                            </a>
                          </li>
                        )
                      )):null}
                    </ul>
                  </div>):(null)):(null)}
                  <div className="mt-3">
                    <h4 className="project-title">Team Members :</h4>
                    <ul className="team-members">
                      {ListOfProjects.projectMembersList !== undefined ? (ListOfProjects.projectMembersList.map(
                        (member, i) => (
                          <li key={i}>
                            <a
                              href="#null"
                              data-toggle="tooltip"
                              title={member.employeeName}
                            >
                              <img
                                alt=""
                                src={!member.profilePicture  || member.profilePicture == "null" || member.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (require(`../../../img/employee/user.png`))}
                              />
                            </a>
                          </li>
                        )
                      )):null}
                    </ul>
                  </div>
                  <div className="mt-2 mb-1">
                    Progress
                    <span className="text-success float-right">30%</span>
                  </div>
                  <Progress value="30" style={{ height: "6px" }}></Progress>
                </CardBody>
               
              </Card>
              </ LazyLoad>
            </Col>
            
          )
          // ))
        )}
    </Fragment>
  );
});

export default CardViewProjects;
